export const CANCEL_REASON_NO_SHOW = 'O paciente não entrou na videochamada'
export const CANCEL_REASON_CONNECTION_PATIENT =
  'Problemas na conexão do paciente'
export const CANCEL_REASON_CONNECTION_PROFESSIONAL =
  'Problemas na conexão do profissional'
export const CANCEL_REASON_PLATFORM = 'Problemas na plataforma'
export const CANCEL_REASON_HEALTH_DECISION = 'Decisão do profissional de saúde'
export const CANCEL_REASON_OTHER = 'Outros'

export function cancelReasonRequiresDetail(reason: string): boolean {
  return (
    reason === CANCEL_REASON_OTHER || reason === CANCEL_REASON_HEALTH_DECISION
  )
}

export function cancelReasonToAnalyticsKey(reason: string): string {
  const map: Record<string, string> = {
    [CANCEL_REASON_NO_SHOW]: 'no_show',
    [CANCEL_REASON_CONNECTION_PATIENT]: 'connection_patient',
    [CANCEL_REASON_CONNECTION_PROFESSIONAL]: 'connection_professional',
    [CANCEL_REASON_PLATFORM]: 'platform',
    [CANCEL_REASON_HEALTH_DECISION]: 'healthcare_decision',
    [CANCEL_REASON_OTHER]: 'other',
  }
  return map[reason] ?? 'unknown'
}
